import { useMutation } from "@apollo/client";

import {
  DeleteInviteToShareGoalMutation,
  DeleteInviteToShareGoalMutationVariables,
  UseDeleteInviteToShareGoalProps,
} from "@ctypes";
import { DELETE_INVITE_TO_SHARE_GOAL, SENT_SHARE_GOAL_INVITES } from "@graphql";

export const useDeleteInviteToShareGoal = ({ goalId }: UseDeleteInviteToShareGoalProps) => {
  return useMutation<DeleteInviteToShareGoalMutation, DeleteInviteToShareGoalMutationVariables>(
    DELETE_INVITE_TO_SHARE_GOAL,
    {
      refetchQueries: [{ query: SENT_SHARE_GOAL_INVITES, variables: { goalId } }],
      awaitRefetchQueries: true,
    },
  );
};
